import BulkWorkflowActionJob from "../../formability/analyst_dashboard/models/bulkWorkflowActionJob";

export default {
  methods:{
    deselectAllEntries(){
      this.$store.commit('bulkActionStore/clearSelectedEntries');
    },
    setSelectAllSeenEntries(){
      //@ts-ignore
      if (event.target.checked) {
        this.$store.commit('bulkActionStore/selectAllSeenEntries', true);
      }else{
        this.$store.commit('bulkActionStore/clearSelectedEntries');
      }
    },
    setSelectAllFilteredEntries(){
      this.$store.commit('bulkActionStore/selectAllFilteredEntries', true);
    }
  },
  computed: {
    bulkActionStore() {
      return this.$store.state.bulkActionStore
    },
    selectedEntries(): string[] {
      let bulkActionStore = this.bulkActionStore;
      if (!!bulkActionStore) {
        return bulkActionStore.selectedEntries;
      } else {
        return [];
      }
    },
    selectedBulkWorkflowActionJob(): BulkWorkflowActionJob | void {
      let bulkActionStore = this.bulkActionStore;
      if (!!bulkActionStore) {
        return bulkActionStore.selectedBulkWorkflowActionJob;
      } else {
        return null;
      }
    },
    allFilteredEntriesSelected(): boolean{
      let bulkActionStore = this.bulkActionStore;
      if (!!bulkActionStore) {
        return bulkActionStore.allFilteredEntriesSelected;
      } else {
        return false;
      }
    },
    allSeenEntriesSelected(): boolean{
      let bulkActionStore = this.bulkActionStore;
      if (!!bulkActionStore) {
        return bulkActionStore.allSeenEntriesSelected;
      } else {
        return false;
      }
    }
  }
};